<template>
  <RfLive class="rf-main-content-wrapper gap-4 [&_.rf-table_.rf-table--wrapper]:px-5">
    <template #title>
      <div class="flex min-h-10 min-w-px">
        <h2 class="text-heading-0 text-black-1">Live</h2>
      </div>
    </template>
  </RfLive>
</template>

<script setup>
import RfLive from "@/blocks/RfLive/RfLive.vue";
</script>
